export const sourceTranslate: { [key: string]: string } = {
  "mercado_livre": "Mercado Livre",
  "shopee": "Shopee",
  "mazelog": "Mazelog",
  "unknown": "Avulso"
};

export const statusChannelTranslate: { [key: string]: string } = {
  "": "-",

  // Mercado Livre
    "handling": "Em processamento",
    "ready_to_ship": "Pronto para envio",
    "first_visit": "Primeira tentativa de entrega",
    "shipped": "Enviado",
    "delivered": "Entregue",
    "to_be_agreed": "A ser acordado",
    "pending": "Pendente",
    "not_delivered": "Não entregue",
    "not_verified": "Não verificado",
    "cancelled": "Cancelado",
    "closed": "Fechado",
    "error": "Erro",
    "active": "Ativo",
    "not_specified": "Não especificado",
    "stale_ready_to_ship": "Pronto para envio (Stale)",
    "stale_shipped": "Enviado (Stale)",

  // Shopee
  "INITIAL": "Inicial",
  "ORDER_INIT": "Pedido iniciado",
  "ORDER_SUBMITTED": "Pedido enviado",
  "ORDER_FINALIZED": "Pedido finalizado",
  "ORDER_CREATED": "Pedido criado",
  "PICKUP_REQUESTED": "Coleta solicitada",
  "PICKUP_PENDING": "Coleta pendente",
  "PICKED_UP": "Coletado",
  "DELIVERY_PENDING": "Entrega pendente",
  "DELIVERED": "Entregue",
  "PICKUP_RETRY": "Reagendamento de coleta",
  "TIMEOUT": "Expirado",
  "LOST": "Perdido",
  "UPDATE": "Atualização",
  "UPDATE_SUBMITTED": "Atualização enviada",
  "UPDATE_CREATED": "Atualização criada",
  "RETURN_STARTED": "Devolução iniciada",
  "RETURNED": "Devolvido",
  "RETURN_PENDING": "Devolução pendente",
  "RETURN_INITIATED": "Devolução iniciada",
  "EXPIRED": "Expirado",
  "CANCEL": "Cancelado",
  "CANCEL_CREATED": "Cancelamento criado",
  "CANCELED": "Cancelado",
  "FAILED_ORDER_INIT": "Falha ao iniciar pedido",
  "FAILED_ORDER_SUBMITTED": "Falha ao enviar pedido",
  "FAILED_ORDER_CREATED": "Falha ao criar pedido",
  "FAILED_PICKUP_REQUESTED": "Falha ao solicitar coleta",
  "FAILED_PICKED_UP": "Falha na coleta",
  "FAILED_DELIVERED": "Falha na entrega",
  "FAILED_UPDATE_SUBMITTED": "Falha ao enviar atualização",
  "FAILED_UPDATE_CREATED": "Falha ao criar atualização",
  "FAILED_RETURN_STARTED": "Falha ao iniciar devolução",
  "FAILED_RETURNED": "Falha na devolução",
  "FAILED_CANCEL_CREATED": "Falha ao criar cancelamento",
  "FAILED_CANCELED": "Falha no cancelamento"
};

export const shopeeLogisticStatusTranslate: { [key: string]: string } = {
  // Status de pagamento e envio
  "UNPAID": "Não pago",
  "READY_TO_SHIP": "Pronto para envio",
  "PROCESSED": "Processado",
  "RETRY_SHIP": "Reenviar",
  "SHIPPED": "Enviado",
  "TO_CONFIRM_RECEIVE": "A confirmar recebimento",
  "IN_CANCEL": "Em cancelamento",
  "CANCELLED": "Cancelado",
  "TO_RETURN": "Devolução",
  "COMPLETED": "Concluído",

  // Status logísticos detalhados
  "LOGISTICS_NOT_STARTED": "Logística não iniciada",
  "LOGISTICS_REQUEST_CREATED": "Envio solicitado",
  "LOGISTICS_PICKUP_DONE": "Coletado pela transportadora",
  "LOGISTICS_PICKUP_RETRY": "Reagendamento de coleta",
  "LOGISTICS_PICKUP_FAILED": "Coleta falhou ou não prosseguiu",
  "LOGISTICS_DELIVERY_DONE": "Entregue com sucesso",
  "LOGISTICS_DELIVERY_FAILED": "Entrega falhou",
  "LOGISTICS_REQUEST_CANCELED": "Envio cancelado",
  "LOGISTICS_COD_REJECTED": "Pedido rejeitado (pagamento na entrega)",
  "LOGISTICS_READY": "Pronto para envio (pagamento aprovado)",
  "LOGISTICS_INVALID": "Pedido inválido/cancelado",
  "LOGISTICS_LOST": "Pedido perdido pela transportadora",
  "LOGISTICS_PENDING_ARRANGE": "Logística pendente de agendamento"
};

export const meliSubStatusTranslate: { [key: string]: string } = {
    "all": "Todos os status",
    "ready_to_print": "Pronto para envio",
    "out_for_delivery": "Saiu para entrega",
    "cost_exceeded": "Custo excedido",
    "under_review": "Em análise (por exemplo, fraude)",
    "reviewed": "Revisado",
    "fraudulent": "Fraudulento",
    "waiting_for_payment": "Aguardando o pagamento do frete ser creditado",
    "shipment_paid": "Custo de envio pago",
    "creating_route": "Rota criada",
    "manufacturing": "Em fabricação",
    "buffered": "Em espera",
    "creating_shipping_order": "Criando ordem de envio",
    "regenerating": "Regenerando",
    "waiting_for_label_generation": "Aguardando geração da etiqueta",
    "invoice_pending": "Nota fiscal pendente",
    "waiting_for_return_confirmation": "Aguardando confirmação de devolução",
    "return_confirmed": "Devolução confirmada",
    "agency_unavailable": "Agência indisponível",
    "printed": "Etiqueta impressa",
    "in_pickup_list": "Na lista de coleta",
    "ready_for_pkl_creation": "Pronto para criação do PKL",
    "ready_for_pickup": "Pronto para coleta",
    "ready_for_dropoff": "Pronto para entrega no ponto de envio",
    "picked_up": "Coletado",
    "stale": "Envio obsoleto",
    "dropped_off": "Entregue no ponto de envio",
    "delayed": "Atrasado",
    "claimed_me": "Envio obsoleto reivindicado pelo comprador",
    "waiting_for_last_mile_authorization": "Aguardando autorização da última milha",
    "rejected_in_hub": "Rejeitado no hub",
    "in_transit": "Em trânsito",
    "in_warehouse": "No armazém",
    "ready_to_pack": "Pronto para embalar",
    "in_hub": "No hub",
    "measures_ready": "Medidas e peso prontos",
    "waiting_for_carrier_authorization": "Aguardando autorização do transportador",
    "authorized_by_carrier": "Autorizado pelo transportador",
    "in_packing_list": "Na lista de embalagem",
    "in_plp": "Na PLP",
    "on_hold": "Em espera",
    "packed": "Embalado",
    "on_route_to_pickup": "A caminho da coleta",
    "picking_up": "Coletando",
    "shipping_order_initialized": "Ordem de envio inicializada",
    "looking_for_driver": "Procurando motorista",
    "waiting_for_withdrawal": "Aguardando retirada",
    "contact_with_carrier_required": "Contato com o transportador necessário",
    "receiver_absent": "Destinatário ausente",
    "reclaimed": "Reclamado",
    "not_localized": "Não localizado",
    "forwarded_to_third": "Encaminhado para terceiro",
    "soon_deliver": "Entrega em breve",
    "refused_delivery": "Entrega recusada",
    "bad_address": "Endereço incorreto",
    "changed_address": "Endereço alterado",
    "negative_feedback": "Envio obsoleto com feedback negativo",
    "need_review": "Necessário revisar status do transportador",
    "operator_intervention": "Intervenção do operador necessária",
    "retained": "Retido",
    "delivery_failed": "Falha na entrega",
    "waiting_for_confirmation": "Aguardando confirmação",
    "at_the_door": "Entrega na porta do comprador",
    "buyer_edt_limit_stale": "Limite EDT do comprador obsoleto",
    "delivery_blocked": "Entrega bloqueada",
    "awaiting_tax_documentation": "Aguardando documentação fiscal",
    "dangerous_area": "Área perigosa",
    "buyer_rescheduled": "Comprador reagendou",
    "failover": "Falha",
    "at_customs": "Na alfândega",
    "delayed_at_customs": "Atrasado na alfândega",
    "left_customs": "Saiu da alfândega",
    "missing_sender_payment": "Pagamento do remetente ausente",
    "missing_sender_documentation": "Documentação do remetente ausente",
    "missing_recipient_documentation": "Documentação do destinatário ausente",
    "missing_recipient_payment": "Pagamento do destinatário ausente",
    "import_taxes_paid": "Impostos de importação pagos",
    "damaged": "Danificado",
    "fulfilled_feedback": "Cumprido pelo feedback do comprador",
    "no_action_taken": "Sem ação tomada pelo comprador",
    "double_refund": "Reembolso duplo",
    "inferred": "Entrega inferida",
    "returning_to_sender": "Devolvendo ao remetente",
    "to_review": "Envio fechado",
    "destroyed": "Destruído",
    "cancelled_measurement_exceeded": "Envio cancelado por exceder medidas",
    "returned_to_hub": "Retornado ao hub",
    "returned_to_agency": "Retornado à agência",
    "picked_up_for_return": "Coletado para devolução",
    "returning_to_warehouse": "Retornando ao armazém",
    "returning_to_hub": "Retornando ao hub",
    "soon_to_be_returned": "Em breve será devolvido",
    "return_failed": "Falha na devolução",
    "in_storage": "Em armazenamento",
    "pending_recovery": "Recuperação pendente",
    "rejected_damaged": "Rejeitado por dano",
    "refunded_by_delay": "Reembolsado por atraso",
    "shipment_stopped": "Envio parado",
    "stolen": "Roubado",
    "returned": "Devolvido",
    "confiscated": "Confiscado",
    "lost": "Pacote perdido",
    "recovered": "Recuperado",
    "returned_to_warehouse": "Retornado ao armazém",
    "not_recovered": "Não recuperado",
    "detained_at_customs": "Detido na alfândega",
    "detained_at_origin": "Detido na origem",
    "unclaimed": "Não reivindicado pelo vendedor",
    "import_tax_rejected": "Imposto de importação rejeitado",
    "import_tax_expired": "Imposto de importação expirado",
    "rider_not_found": "Entregador não encontrado",
    "label_expired": "Etiqueta expirada",
    "cancelled_manually": "Cancelado manualmente",
    "return_expired": "Devolução expirada",
    "return_session_expired": "Sessão de devolução expirada",
    "unfulfillable": "Não realizável",
    "closed_by_user": "Tipo de envio alterado pelo usuário",
    "pack_splitted": "Pacote dividido",
    "shipped_outside_me": "Enviado fora do sistema",
    "service_unavailable": "Serviço indisponível",
    "dismissed": "Descartado",
    "time_expired": "Tempo expirado",
    "rejected_manually": "Rejeitado manualmente",
    "closed_store": "Loja fechada",
    "out_of_range": "Fora de alcance"
};